import { Injectable } from '@angular/core';
import { Api } from '../providers/api/api';
import { DTOListaCatalogo } from '../dto/dtoListaCatalogo';
import { DTOCheckCatalogo } from '../dto/dtoCheckCatalogo';
import { DTOAcompanharPedido } from '../dto/dtoAcompanharPedido';
import { DTOAcompanharPix } from '../dto/dtoAcompanharPix';
import { DTOEntregaPedido } from '../dto/dtoEntregaPedido';
import { DTOCartelaPendente} from '../dto/dtoCartelaPendente';
import { Pedido } from '../entities/pedido';
import { Pix } from '../entities/pix';
import { LogPedido } from '../entities/logPedido';
import { LogPix} from '../entities/logPix';

@Injectable()
export class PedidoDAO {
    constructor(private _api: Api) { }

    public adicionarPix(pix: Pix): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Pix/AddPix', { pix: pix}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });

    }
    /*
    public solicitarPgtoPix(pix: Pix): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.post('Pix', pix).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }
        */

    public deletarCatalogo(dtoListaCatalogo: DTOListaCatalogo): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Pedido/DeletarCatalogo', { dtoListaCatalogo: dtoListaCatalogo}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });

    }

    public listaCatalogoPorPicote(idEmpresa: number,qtdePicote: number ): Promise<DTOListaCatalogo[]>{
        return new Promise((resolve, reject) => {
            let listaCatalogo: DTOListaCatalogo[] = [];

            this._api.get(`Pedido/ListaCatalogo/${idEmpresa}/${qtdePicote}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    listaCatalogo.push(new DTOListaCatalogo().deserialize(element));
                });
                resolve(listaCatalogo);
            }, error => {
                reject(error);
            });
        });
    }

    public DeletarReferencia(idEmpresa: number,redProdutoKey: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.get(`Pedido/DeletarReferencia/${idEmpresa}/${redProdutoKey}`).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public AddReferencia(idEmpresa: number,redProdutoKey: number,qtdPicote: number ): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.get(`Pedido/CadastrarReferencia/${idEmpresa}/${redProdutoKey}/${qtdPicote}`).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }

    public listaCheckCatalogo(idEmpresa: number, referencia: string): Promise<DTOCheckCatalogo[]>{
        return new Promise((resolve, reject) => {
            let listaCatalogo: DTOCheckCatalogo[] = [];

            this._api.get(`Pedido/CheckCatalogo/${idEmpresa}/${referencia}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    listaCatalogo.push(new DTOCheckCatalogo().deserialize(element));
                });
                resolve(listaCatalogo);
            }, error => {
                reject(error);
            });
        });
    }

    public listaCatalogo(idEmpresa: number): Promise<DTOListaCatalogo[]>{
        return new Promise((resolve, reject) => {
            let listaCatalogo: DTOListaCatalogo[] = [];

            this._api.get(`Pedido/ListaCatalogo/${idEmpresa}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    listaCatalogo.push(new DTOListaCatalogo().deserialize(element));
                });
                resolve(listaCatalogo);
            }, error => {
                reject(error);
            });
        });
    }


    public listaPedidoSemEntrega(idEmpresa: number, idUsuario: number): Promise<DTOAcompanharPedido[]>{
        return new Promise((resolve, reject) => {
            let listaPedido: DTOAcompanharPedido[] = [];

            this._api.get(`Pedido/ListaPedidoSemEntrega/${idEmpresa}/${idUsuario}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    listaPedido.push(new DTOAcompanharPedido().deserialize(element));
                });
                resolve(listaPedido);
            }, error => {
                reject(error);
            });
        });
    }


    public listaPix(idEmpresa: number, idUsuario: number, admin: boolean, dtInicio: string, dataFinal: string, numCartela: string): Promise<DTOAcompanharPix[]>{
        return new Promise((resolve, reject) => {
            let listaPedido: DTOAcompanharPix[] = [];

            this._api.get(`Pix/ListaPix/${idEmpresa}/${idUsuario}/${admin}/${dtInicio}/${dataFinal}/${numCartela}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    listaPedido.push(new DTOAcompanharPix().deserialize(element));
                });
                resolve(listaPedido);
            }, error => {
                reject(error);
            });
        });
    }

    public listaCartelaPendente(idEmpresa: number): Promise<DTOCartelaPendente[]>{
        return new Promise((resolve, reject) => {
            let lista: DTOCartelaPendente[] = [];

            this._api.get(`Pix/ListaCartelaPendente/${idEmpresa}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    lista.push(new DTOCartelaPendente().deserialize(element));
                });
                resolve(lista);
            }, error => {
                reject(error);
            });
        });
    }


    public listaPedido(idEmpresa: number, idUsuario: number, admin: boolean, dtInicio: string, dataFinal: string, numCartela: string): Promise<DTOAcompanharPedido[]>{
        return new Promise((resolve, reject) => {
            let listaPedido: DTOAcompanharPedido[] = [];

            this._api.get(`Pedido/ListaPedido/${idEmpresa}/${idUsuario}/${admin}/${dtInicio}/${dataFinal}/${numCartela}`).subscribe(res => {
                JSON.parse(res._body).forEach(element => {
                    listaPedido.push(new DTOAcompanharPedido().deserialize(element));
                });
                resolve(listaPedido);
            }, error => {
                reject(error);
            });
        });
    }


    public adicionarPedido(pedido: Pedido): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Pedido/AddPedido', { pedido: pedido}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });

    }



    public gravarEntregaPedido(dtoEntregaPedido: DTOEntregaPedido): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Pedido/GravarEntregaPedido', { dtoEntregaPedido: dtoEntregaPedido}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }


    public criarLogPix(logPix: LogPix): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Pix/GravarLogPix', { logPix: logPix}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    } 

    public criarLogPedido(logPedido: LogPedido): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Pedido/GravarLogPedido', { logPedido: logPedido}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    } 

    public receberCartelaPendente(dtoCartelaPendente: DTOCartelaPendente): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.put('Pedido/ReceberCartela', { dtoCartelaPendente: dtoCartelaPendente}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    } 

    public criarPedido(pedido: Pedido): Promise<any> {
        return new Promise((resolve, reject) => {
           // console.log('www');
            this._api.put('Pedido/GravarPedido', { pedido: pedido}).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    } 


    public VerificarGrupoClientePix(pCNPJ: string ): Promise<any> {
        return new Promise((resolve, reject) => {
            this._api.get(`Pedido/VerificarGrupoClientePix/${pCNPJ}`).subscribe(res => {
                resolve(JSON.parse(res._body));
            }, error => {
                reject(error);
            });
        });
    }




}



// WEBPACK FOOTER //
// ./src/daos/pedido-dao.ts